<form #importForm="ngForm">
  <div class="mct-flex mct-col mct-gap-27"  >
    <h1>{{ 'events.registration-import.header' | translate | titlecase }}</h1>
    <div>
      <p-fileUpload
        name="uploadedfiles[]"
        multiple="multiple"
        required="true"
        [showUploadButton]="false"
        [showCancelButton]="false"
        (onSelect)="selectFile($event)"
        (onRemove)="removeFile()"
        fileLimit="1"
      >
        <ng-template pTemplate="toolbar">
          <button pButton type="button" class="p-button-outlined" (click)="downloadTemplate()">
            {{ 'admin.import-invoices.download-template' | translate | titlecase }}
          </button>
        </ng-template>
        <ng-template pTemplate="content" let-files let-removeFileCallback="removeFileCallback">
          <div *ngFor="let file of files; let i = index" class="mct-flex mct-row mv-5">
            <span class="mr-5">{{ file.name }}</span>
            <button
              pButton
              type="button"
              icon="pi pi-times"
              class="atlas-btn atlas-btn-secondary"
              (click)="removeFileCallback($event, i)"
            ></button>
          </div>
        </ng-template>
      </p-fileUpload>
    </div>
    <div class="mct-flex mct-row">
      <label  class="mv-10 w-10 f-wb mct-flex-0-0-200px"> {{ 'events.registration-import.event-id' | translate | titlecase }} </label>
      <input class="mct-flex-0-0-200px"
        name="eventId"
        #eventId="ngModel"

        required="true"
        [(ngModel)]="importConfig.EventId"
        (change)="eventIdChanged()"
      />
    </div>
    <div class="mct-flex mct-row">
      <label  class="mv-10 w-10 f-wb mct-flex-0-0-200px">
        {{ 'events.registration-import.default-event-item' | translate | titlecase }}
      </label>
      <div class="mct-flex-0-0-200px">
        <div class="mb-10">
          <p-select
            required="true"
            name="defaultEvendItemId"
            styleClass="w-100"
            [(ngModel)]="importConfig.DefaultEventItemId"
            [options]="eventItemOptions"
          >
          </p-select>
        </div>
        <span *ngIf="!eventItemOptions?.length && optionsRan" class="text-danger">
          {{ 'events.registration-import.create-an-event-item' | translate | titlecase }}
        </span>
      </div>
    </div>
    <div>
      <div  class="mv-10 mct-flex mct-row" *ngFor="let email of notificationEmails; let i = index">
        <label  class="mv-10 w-10 f-wb mct-flex-0-0-200px" for="emailField">{{
          'common.personal-information.email' | translate | titlecase
        }}</label>
        <input

          id="emailField"
          name="emailField-{{ i }}"
          type="email"
          class="mr-5 w-10 mct-flex-0-0-200px"
          [(ngModel)]="email.value"
          [required]="i == 0"
          [placeholder]="'common.placeholder-email' | translate | ucfirst"
          email="true"
          #emailField="ngModel"
        />
        <button pButton type="button" *ngIf="i != 0" class="atlas-btn atlas-btn-primary wp-35" (click)="removeEmail(i)"><i class="pi pi-minus"></i></button>
        <button pButton type="button" *ngIf="i == 0" class="atlas-btn atlas-btn-primary wp-35" (click)="addEmail()"><i class="pi pi-plus"></i></button>
        <div *ngIf="emailField.invalid && (emailField.dirty || emailField.touched)" class="mv-10 ml-5 email-error">
          {{ 'events.registration-import.email-error' | translate | ucfirst }}
        </div>
      </div>
    </div>
    <div>
      <button
        [disabled]="importStarted || importForm.invalid || !fileSelected"
        class="atlas-btn atlas-btn-primary btn-big"
        (click)="importRegistrations()"
      >
        {{ 'events.registration-import.import' | translate | titlecase }}
      </button>
    </div>
  </div>
</form>
